import React from 'react'
import { useHistory } from 'react-router-dom'
import { Group } from '@mantine/core'
import AppButton from '../../app/common/ui/AppButton'
import { SLOP_FEED_MOBILE_MQ } from './slopFeedLayout'

interface SlopSecondaryNavProps {
  mode: 'discover' | 'library' | 'embed'
  isAdmin?: boolean
}

export default function SlopSecondaryNav ({ mode, isAdmin }: SlopSecondaryNavProps) {
  const history = useHistory()

  return (
    <Group
      spacing="sm"
      sx={{
        marginBottom: 12,
        flexWrap: 'wrap',
        [SLOP_FEED_MOBILE_MQ]: { marginBottom: 8 }
      }}
    >
      {mode !== 'discover' && (
        <AppButton
          variant="subtle"
          size="xs"
          compact
          onClick={() => history.push('/slop-feed')}
          sx={{ color: 'var(--gs-muted)' }}
        >
          ← Discover
        </AppButton>
      )}
      {mode === 'discover' && (
        <AppButton
          variant="subtle"
          size="xs"
          compact
          onClick={() => history.push('/slop-feed/library')}
          sx={{ color: 'var(--gs-muted)', marginLeft: 'auto' }}
        >
          Video library →
        </AppButton>
      )}
      {mode === 'library' && isAdmin && (
        <AppButton
          variant="subtle"
          size="xs"
          compact
          onClick={() => history.push('/slop-feed/embed')}
          sx={{ color: 'var(--gs-muted)', marginLeft: 'auto' }}
        >
          Embed video (admin)
        </AppButton>
      )}
      {mode === 'embed' && (
        <AppButton
          variant="subtle"
          size="xs"
          compact
          onClick={() => history.push('/slop-feed/library')}
          sx={{ color: 'var(--gs-muted)', marginLeft: 'auto' }}
        >
          ← Video library
        </AppButton>
      )}
    </Group>
  )
}
